


























































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';
import BusinessUpdateAddressForm from './BusinessUpdateAddressForm.vue';
import _ from 'lodash';

@Component({
  components: {
    BusinessUpdateAddressForm,
  },
  computed: {
    ...mapState('Business', {
      business: 'business',
    }),
    ...mapState('Country', {
      countries: 'countries',
    }),
  },
})
export default class BusinessUpdateAddressList extends Vue {
  business!: Model;
  @Prop({ default: false }) addBillingAddress!: boolean;
  @Prop({ default: false }) addPostalAddress!: boolean;

  isMounted = false;

  selectedAddress = {
    address1: '',
    address2: '',
    city: '',
    postcode: '',
    country_id: '',
    state_id: '',
    is_billing: this.addBillingAddress,
    is_postal: this.addPostalAddress,
  };

  showSheet = false;

  headers = [
    {
      text: 'Address',
      value: 'address',
    },
    {
      text: ' ',
      value: 'is_billing',
    },
    {
      text: 'Actions',
      value: 'actions',
      sortable: false,
    },
  ];

  countries!: [
    {
      id: number;
      name: string;
      states: {
        id: number;
        name: string;
      }[];
    }
  ];

  mounted() {
    this.$store
      .dispatch('Country/fetchList', {
        params: {
          expand: ['states'],
        },
      })
      .then(() => {
        this.isMounted = true;
      });
  }

  generateNewAddress() {
    return {
      address1: '',
      address2: '',
      city: '',
      postcode: '',
      country_id: '',
      state_id: '',
      is_billing: this.addBillingAddress,
      is_postal: this.addPostalAddress,
    };
  }

  addAddress() {
    this.showSheet = true;
    this.selectedAddress = this.generateNewAddress();
  }

  editAddress(address) {
    this.showSheet = true;
    this.selectedAddress = _.cloneDeep(address);
  }

  deleteAddress(address) {
    this.$store.dispatch('BusinessAddress/delete', address);
  }

  setAsBilling(address) {
    this.$store.dispatch('BusinessAddress/billingAddress', address).then(() => {
      this.$store.dispatch('Business/fetch', {
        businessOid: this.business.object_id,
        config: {
          params: {
            expand: [
              'business_contacts',
              'business_addresses',
              'billing_address',
              'billing_contact',
              'postal_address',
              'primary_contact',
              'director_contact',
            ],
          },
        },
      });
    });
  }

  setAsPostal(address) {
    this.$store.dispatch('BusinessAddress/postalAddress', address).then(() => {
      this.$store.dispatch('Business/fetch', {
        businessOid: this.business.object_id,
        config: {
          params: {
            expand: [
              'business_contacts',
              'business_addresses',
              'billing_address',
              'billing_contact',
              'postal_address',
              'primary_contact',
              'director_contact',
            ],
          },
        },
      });
    });
  }

  rowStyle() {
    // if (
    //   this.business.billing_address &&
    //   address.object_id == this.business.billing_address.object_id
    // ) {
    //   return "teal lighten-4"
    // }
    return '';
  }

  toAddress(v) {
    let address = v.address1;
    if (v.address2) {
      address += ', ' + v.address2;
    }
    if (v.city) {
      address += ', ' + v.city;
    }
    if (v.postcode) {
      address += ', ' + v.postcode;
    }
    if (v.state_id && v.country_id) {
      const country = this.countries.find(
        (country) => country.id == v.country_id
      );
      const state = country?.states.find((state) => state.id == v.state_id);
      if (country && state) {
        address += ', ' + state.name + ', ' + country.name;
      }
    }
    return address;
  }
}
